// Copyright (C) Okahu Inc 2023-2024. All rights reserved.

import { AppGraph } from 'types/api-data';

import { FACT_NAME_LABEL_MAP } from '@/components/display-page/fact-name-label-map';

export const getAlertFactConfig = (
  slaConfig: AppGraph['sla_config'],
  type: 'performance' | 'budget'
) => {
  const config = slaConfig?.[type];
  if (!config) return null;

  // find the fact marked as default alert
  const alertEntry = Object.entries(config).find(([, value]: any) =>
    value?.alert?.includes('pill')
  );
  if (!alertEntry) return null;

  const [factType, factConfig] = alertEntry as [
    string,
    { value: number; unit: string },
  ];

  return {
    factType,
    label: FACT_NAME_LABEL_MAP[factType]?.label || factType,
    value: factConfig.value,
    unit: factConfig.unit,
  };
};
